const danhSachTatCaQuyen = state => state.danhSachTatCaQuyen;
const danhSachQuyenTrongAppPaging = state => state.danhSachQuyenTrongAppPaging;
const danhSachTatCaQuyenTrongApp = state => state.danhSachTatCaQuyenTrongApp;
const danhSachQuyenKhongThuocVaiTro = state => state.danhSachQuyenKhongThuocVaiTro;
const danhSachQuyenTheoVaiTro = state => state.danhSachQuyenTheoVaiTro;
const danhSachQuyenKhongThuocGroup = state => state.danhSachQuyenKhongThuocGroup;

export default {
  danhSachTatCaQuyen,
  danhSachQuyenTrongAppPaging,
  danhSachTatCaQuyenTrongApp,
  danhSachQuyenKhongThuocVaiTro,
  danhSachQuyenTheoVaiTro,
  danhSachQuyenKhongThuocGroup
};
